export enum ModuleName {
    EMPLOYEE_PRIV_SCHEDULE_TOOL = "EMPLOYEE_PRIV_SCHEDULE_TOOL",
}

